import React from 'react';
export function Footer() {
  return <footer className="bg-brand-footer py-12 px-4 text-center border-t border-brand-border-soft" data-id="element-147">
      <div className="container mx-auto max-w-3xl" data-id="element-148">
        <h3 className="text-xl font-serif font-bold text-white mb-4 tracking-wider" data-id="element-149">
          🌸 ACADEMIA HOLÍSTICA ARGENTINA™
        </h3>

        <p className="text-brand-footer-text text-sm md:text-base leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-150">
          El sistema de bienestar femenino holístico más completo de Argentina.
          Porque reconectarte con tu cuerpo, tu energía y tu femineidad no
          debería postergarse por falta de un método a la altura.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-10 text-sm text-brand-border-soft" data-id="element-151">
          <a href="mailto:academiaholisticaargentina@gmail.com" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-152">
            📧 academiaholisticaargentina@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-153">
            📲 Instagram: @academiaholisticaargentina
          </a>
          <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-154">
            📘 Facebook: Academia Holística Argentina
          </a>
        </div>

        <div className="text-xs text-white/50 space-y-4" data-id="element-155">
          <p data-id="element-156">
            © Academia Holística Argentina™ 2026 — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa. Este material tiene fines informativos y de
            bienestar personal. No reemplaza el diagnóstico ni el tratamiento
            médico.
          </p>
          <p className="font-display italic text-brand-border-soft text-lg" data-id="element-157">
            🌸 "Tu cuerpo te habla. Aprendé a escucharlo."
          </p>
        </div>
      </div>
    </footer>;
}